import { apiAxios } from '@/lib/apiAxios';
import { format } from 'date-fns';
import { DATE_FORMAT_ISO } from '@/constants/date';
const buildParams = ({ from, to, excludeDevices, excludeBrowsers }) => ({
    from: format(from, DATE_FORMAT_ISO),
    to: format(to, DATE_FORMAT_ISO),
    'excludeDevices[]': excludeDevices,
    'excludeBrowsers[]': excludeBrowsers,
});
export const fetchABTesting = ({ publicId, ...filter }) => apiAxios
    .get(`/campaigns/${publicId}/ab-testings`, { params: buildParams(filter) })
    .then((response) => response.data);
export const fetchTrackingLinks = ({ publicId, ...filter }) => apiAxios
    .get(`/campaigns/${publicId}/ab-testings/tracking-links`, { params: buildParams(filter) })
    .then((response) => response.data);
export const fetchCampaignEntryPoints = ({ publicId, ...filter }) => apiAxios
    .get(`/campaigns/${publicId}/ab-testings/entry-points`, { params: buildParams(filter) })
    .then((response) => response.data);
export const fetchTrackingEntryPoints = ({ publicId, ...filter }) => apiAxios
    .get(`/tracking-links/${publicId}/ab-testings/entry-points`, { params: buildParams(filter) })
    .then((response) => response.data);
export const exportCampaignTrackingLinks = ({ publicId, fileFormat = 'csv', ...filter }) => apiAxios.get(`/campaigns/${publicId}/ab-testings/exports/tracking-links.${fileFormat}`, {
    params: buildParams(filter),
    responseType: 'blob',
});
export const exportCampaignEntryPoints = ({ publicId, fileFormat = 'csv', ...filter }) => apiAxios.get(`/campaigns/${publicId}/ab-testings/exports/entry-points.${fileFormat}`, {
    params: buildParams(filter),
    responseType: 'blob',
});
export const exportTrackingLinkEntryPoints = ({ publicId, fileFormat = 'csv', ...filter }) => apiAxios.get(`/tracking-links/${publicId}/ab-testings/exports/entry-points.${fileFormat}`, {
    params: buildParams(filter),
    responseType: 'blob',
});
